//克隆对象
function deepCopy(obj) {
	if (typeof obj != 'object') {
		return obj;
	}
	var newobj = {};
	for (var attr in obj) {
		newobj[attr] = deepCopy(obj[attr]);
	}
	return newobj;
}
//验证（类似phpapi的验证）
/* 
{
	name:'message',（obj中的message）
	type:'chinese',
	re:表达式，（和type有一个即可）
	min:0,(默认为0，不限制)
	max:100,(默认为0，不限制)
}
*/
var isValid = function (obj, valids) {
	var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	var numberRE = /^[0-9]*$/
	var chineseRE = /^[\u4e00-\u9fa5]{0,}$/
	var retypes = { email: emailRE, number: numberRE, chinese: chineseRE }
	var validation = {}
	var errors = []

	valids.forEach(function (p) {
		/* if(obj.type && !obj.re && !obj.min && !obj.max){
			validation.others=false
			errors.push({name:'others',mesage:'规则表达式re不能为空或者type必须为number、email、chinese'})
			console.log('isValid:规则表达式re不能为空或者type必须为number、email、chinese')
		} */
		//长度限制
		var len = obj[p.name].length
		var min = p.min || 0
		var max = p.max || 500
		if (len >= max) {
			validation[p.name] = false
			errors.push({ name: p.name, mesage: p.name + '(' + obj[p.name] + ')必须小于等于：' + max })
		}
		if (len <= min) {
			validation[p.name] = false
			errors.push({ name: p.name, mesage: p.name + '(' + obj[p.name] + ')必须大于等于：' + min })
		}
		//类型限制
		if (p.type in retypes) {
			validation[p.name] = retypes[p.type].test(obj[p.name])
			if (!validation[p.name]) errors.push({ name: p.name, mesage: '必须为' + p.type })
		} else if (p.re in retypes) {
			validation[p.name] = p.re.test(obj[p.name])
			if (!validation[p.name]) errors.push({ name: p.name, mesage: '必须满足：[' + p.re + ']表达式' })
		}
	})
	var res = Object.keys(validation).every(function (key) {
		return validation[key]
	})
	return { value: res, errors: errors }
}
//获取当前日期
function getNowFormatDate() {
	var date = new Date();
	var seperator1 = "-";
	var seperator2 = ":";
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
		+ " " + date.getHours() + seperator2 + date.getMinutes()
		+ seperator2 + date.getSeconds();
	return currentdate;
}
//下载文件
function saveFile(data, filename) {
	var save_link = document.createElement('a');
	save_link.href = data;
	save_link.download = filename;

	var event = document.createEvent('MouseEvents');
	event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	save_link.dispatchEvent(event);
};
function savePNG(filename, img) {
	// 下载后的问题名
	filename = filename + (new Date()).getTime();
	saveFile(img, filename)
}
function saveSVG(filename) { console.log('saveSVG:', filename) }


function showTooltip(target) {
	console.log('showTooltip', target)
}
/*
* 频率控制 返回函数连续调用时，fn 执行频率限定为每多少时间执行一次
* @param fn {function}  需要调用的函数
* @param delay  {number}    延迟时间，单位毫秒
* @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
* @return {function}实际调用函数
*/
function throttle(fn, delay, immediate, debounce) {
	var curr = +new Date(),//当前事件
		last_call = 0,
		last_exec = 0,
		timer = null,
		diff, //时间差
		context,//上下文
		args,
		exec = function () {
			last_exec = curr;
			fn.apply(context, args);
		};
	return function () {
		curr = +new Date();
		context = this,
			args = arguments,
			diff = curr - (debounce ? last_call : last_exec) - delay;
		clearTimeout(timer);
		if (debounce) {
			if (immediate) {
				timer = setTimeout(exec, delay);
			} else if (diff >= 0) {
				exec();
			}
		} else {
			if (diff >= 0) {
				exec();
			} else if (immediate) {
				timer = setTimeout(exec, -diff);
			}
		}
		last_call = curr;
	}
};

/*
* 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 delay，fn 才会执行
* @param fn {function}  要调用的函数
* @param delay   {number}    空闲时间
* @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
* @return {function}实际调用函数
*/

function debounce(fn, delay, immediate) {
	return throttle(fn, delay, immediate, true);
};
exports.deepCopy = deepCopy;
exports.isValid = isValid;
exports.getNowFormatDate = getNowFormatDate;
exports.saveFile = saveFile;
exports.saveSVG = saveSVG;
exports.savePNG = savePNG;
exports.showTooltip = showTooltip;
exports.throttle = throttle;
exports.debounce = debounce;


// WEBPACK FOOTER //
// ./src/common.js